/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./fallbackErrorPage.vue?vue&type=template&id=5507f5e0&scoped=true"
import script from "./fallbackErrorPage.vue?vue&type=script&lang=js"
export * from "./fallbackErrorPage.vue?vue&type=script&lang=js"
import style0 from "./fallbackErrorPage.vue?vue&type=style&index=0&id=5507f5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507f5e0",
  null
  
)

export default component.exports